
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/track-shipment",
      function () {
        return require("private-next-pages/track-shipment/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/track-shipment"])
      });
    }
  